function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "E4H/collection");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "\\uD83D\\uDDA5-Wireframes-Desktop",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Activities-Preview-Prototype-Alt",
  transform: "translate(-1212.000000, -29.000000)"
}, React.createElement("g", {
  id: "E4H/collection",
  transform: "translate(1212.000000, 29.000000)"
}, React.createElement("g", {
  id: "collection"
}, React.createElement("g", {
  id: "Rectangle"
}, React.createElement("g", {
  id: "Mask",
  fill: "#009BDF",
  fillRule: "nonzero"
}, React.createElement("rect", {
  id: "Rectangle",
  x: 9.15384615,
  y: 22.5932203,
  width: 9.69230769,
  height: 1.05084746
}), React.createElement("rect", {
  id: "Rectangle-Copy",
  x: 9.05882353,
  y: 10.6052632,
  width: 10.7058824,
  height: 1.05084746
}), React.createElement("rect", {
  id: "Rectangle-Copy-2",
  x: 9.05882353,
  y: 13.0526316,
  width: 6.58823529,
  height: 1.05084746
}), React.createElement("rect", {
  id: "Rectangle-Copy-3",
  x: 9.05882353,
  y: 15.5,
  width: 4.94117647,
  height: 1.05084746
}), React.createElement("polygon", {
  id: "Path",
  points: "23.6923077 19.440678 22.6153846 19.440678 22.6153846 5.77966102 5.38461538 5.77966102 5.38461538 19.440678 4.30769231 19.440678 4.30769231 4.72881356 23.6923077 4.72881356"
}), React.createElement("path", {
  d: "M28,31 L0,31 L0,20.4915254 L7.53846154,20.4915254 L7.53846154,21.0169492 L8.07692308,21.0169492 L8.07692308,24.6949153 L19.9230769,24.6949153 L19.9230769,20.4915254 L28,20.4915254 L28,31 Z M1.07692308,29.9491525 L26.9230769,29.9491525 L26.9230769,21.5423729 L21,21.5423729 L21,25.7457627 L7,25.7457627 L7,21.5423729 L1.07692308,21.5423729 L1.07692308,29.9491525 Z",
  id: "Shape"
}), React.createElement("polygon", {
  id: "Rectangle",
  transform: "translate(1.873117, 18.150321) rotate(24.463397) translate(-1.873117, -18.150321) ",
  points: "1.3666375 14.9629865 2.43905826 14.9531579 2.37959558 21.3376562 1.30717482 21.3474848"
}), React.createElement("polygon", {
  id: "Rectangle",
  transform: "translate(26.125664, 18.152034) rotate(65.556994) translate(-26.125664, -18.152034) ",
  points: "22.9381626 17.6455039 29.3229881 17.5860747 29.3131651 18.6585645 22.9283396 18.7179938"
}), React.createElement("polygon", {
  id: "Path",
  points: "22.6153846 3.6779661 21.5384615 3.6779661 21.5384615 3.15254237 6.46153846 3.15254237 6.46153846 3.6779661 5.38461538 3.6779661 5.38461538 2.10169492 22.6153846 2.10169492"
}), React.createElement("polygon", {
  id: "Path",
  points: "21.5384615 1.57627119 20.4615385 1.57627119 20.4615385 1.05084746 7.53846154 1.05084746 7.53846154 1.57627119 6.46153846 1.57627119 6.46153846 0 21.5384615 0"
})))))));

var SvgCollection = function SvgCollection(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "28px",
    height: "31px",
    viewBox: "0 0 28 31",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCollection, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/collection.5566b358.svg";
export { ForwardRef as ReactComponent };